<template>
  <a-drawer title="发放优惠券" :visible="visible" :width="800" @close="close" destroyOnClose>
    <a-form layout="inline">
      <a-form-item label="用户手机号">
        <a-input v-model="queryParam.userPhone" />
      </a-form-item>
      <a-form-item>
        <a-button type="primary" @click="handleQuery">查询</a-button>
        <a-button style="margin-left: 8px" @click="resetQuery">重置</a-button>
      </a-form-item>
    </a-form>

    <a-table
      style="margin-top: 16px"
      rowKey="id"
      :columns="columns"
      :data-source="list"
      :pagination="pagination"
      :row-selection="rowSelection"
      :loading="loading"
    />

    <div
      :style="{
        position: 'absolute',
        right: 0,
        bottom: 0,
        width: '100%',
        borderTop: '1px solid #e9e9e9',
        padding: '10px 16px',
        background: '#fff',
        textAlign: 'right',
        zIndex: 1,
      }"
    >
      <a-button style="margin-right: 8px" @click="close">取消</a-button>
      <a-button type="primary" :loading="submitting" @click="submit">发放</a-button>
    </div>
  </a-drawer>
</template>

<script>
import { fetchList } from '@/api/declaration/customer'
import { distributeCoupon } from '@/api/coupon/controller'

export default {
  data() {
    return {
      visible: false,
      couponId: null,
      loading: false,
      submitting: false,
      selectedRowKeys: [],
      list: [],
      queryParam: {
        pageNum: 1,
        pageSize: 10,
      },
      pagination: {
        current: 1,
        total: 0,
        showSizeChanger: true,
        showQuickJumper: true,
        onChange: this.onPageChange,
        onShowSizeChange: this.onSizeChange,
      },
      columns: [
        { title: '用户手机号', dataIndex: 'userPhone', align: 'center' },
        { title: '店铺名称', dataIndex: 'shopName', align: 'center' },
        { title: '联系名称', dataIndex: 'name', align: 'center' },
        { title: '联系电话', dataIndex: 'phone', align: 'center' },
      ],
    }
  },
  computed: {
    rowSelection() {
      return {
        selectedRowKeys: this.selectedRowKeys,
        onChange: this.onSelectChange,
      }
    },
  },
  methods: {
    onSelectChange(keys) {
      this.selectedRowKeys = keys
    },
    open(couponId) {
      this.couponId = couponId
      this.visible = true
      this.getList()
    },
    close() {
      this.visible = false
      this.selectedRowKeys = []
      this.queryParam = {
        pageNum: 1,
        pageSize: 10,
      }
    },
    getList() {
      this.loading = true
      fetchList(this.queryParam).then((res) => {
        this.list = res.data.records
        this.pagination.total = res.data.total
        this.pagination.current = this.queryParam.pageNum
        this.loading = false
      })
    },
    handleQuery() {
      this.queryParam.pageNum = 1
      this.getList()
    },
    resetQuery() {
      this.queryParam = {
        pageNum: 1,
        pageSize: 10,
        userPhone: '',
      }
      this.getList()
    },
    onPageChange(page, size) {
      this.queryParam.pageNum = page
      this.queryParam.pageSize = size
      this.getList()
    },
    onSizeChange(current, size) {
      this.queryParam.pageNum = 1
      this.queryParam.pageSize = size
      this.getList()
    },
    submit() {
      if (!this.selectedRowKeys.length) {
        this.$message.warning('请选择用户')
        return
      }
      this.submitting = true
      distributeCoupon({
        couponId: this.couponId,
        objIds: this.selectedRowKeys,
      })
        .then(() => {
          this.$message.success('发放成功')
          this.$emit('success')
          this.close()
        })
        .finally(() => {
          this.submitting = false
        })
    },
  },
}
</script>
